const faqMain = {
  title: 'FAQ',
  faqs: {
    aboutProduct: {
      title: '/ About the Product',
      questions: {
        q1: {
          question: 'IS THE PEGASUS ARMS UAV CERTIFIED?',
          answer:
            'Yes, it is. Pegasus Arms 25 is codified (approved for operation) by the Ministry of Defense of Ukraine and officially recognized as a recommended UAV. This allows procurement via government agencies, volunteer funds, military units, city councils, and allocated funds.',
        },
        q2: {
          question: 'What are the key performance parameters of the drone?',
          answer: [
            'Payload capacity: up to 14 kg',
            'Flight duration: up to 45 minutes',
            'Communication range: up to 30 km',
            'Maximum speed: up to 110 km/h',
            'EW resistance: FHSS (stable)',
            'Wind resistance: up to 20 m/s',
            'Reusable',
          ],
        },
      },
    },
    manufacturing: {
      title: '/ Manufacturing and Maintenance',
      questions: {
        q1: {
          question: 'HOW LONG DOES IT TAKE TO PRODUCE ONE SYSTEM?',
          answer:
            'The standard production time is 7–14 days. Priority deliveries are possible for urgent needs of the Defense Forces.',
        },
        q2: {
          question: 'DOES THE COMPANY PROVIDE MAINTENANCE SERVICE?',
          answer:
            'Yes, it does. The company provides 24/7 service and technical support, as well as consultations, repairs, and software updates for 12 months. An essential condition is the availability of  a UAV operator certificate issued after training completion.',
        },
      },
    },
    training: {
      title: '/ Training and Application',
      questions: {
        q1: {
          question: 'DOES THE COMPANY PROVIDE UAV OPERATOR TRAINING?',
          answer:
            'Yes, it does. As a manufacturer, we provide a full training cycle for UAV/UAS operators – from the theoretical course to actual flights. We also cooperate with partners authorized to train cadets to use the Pegasus Arms 25 UAVs, including Territorial Defense Forces, separate Territorial Defense Brigades, and Ground Forces. Training is given by veterans who are field-experienced professionals.',
        },
        q2: {
          question: 'WHERE HAVE THE PEGASUS ARMS 25 UAVS BEEN USED? ',
          answer:
            'Our drones are made active use of by units of Defense Forces along the entire front line. In total, more than 50 combat brigades use our UAVs on a daily basis.',
        },
      },
    },
    order: {
      title: '/ Orders and Support',
      questions: {
        q1: {
          question: 'Can you order a drone as a volunteer or a fund?',
          answer:
            'Yes, you can. We also sign direct contracts with military units and government administrations.',
        },
        q2: {
          question: 'HOW CAN I GET A CONSULTATION WITH A SPECIALIST?',
          answer:
            'Fill out the form on the website or send your inquiry to the company’s official email p.info@pegasusarms.com.',
        },
      },
    },
  },
}
export default faqMain
